import createEmailPasswordLoginPage from '../../react-components/login/create-login-page';

const MemberLogin = createEmailPasswordLoginPage(
  'Member Login',
  'member',
  'sessions/member',
  '/',
  <p>
    Join FITSOCIETY.COM as a member to save your location for future category searches and optionally receive occasional
    promotional emails based on your selected interests.
  </p>,
  '/member-registration'
);

export default MemberLogin;
